import React from 'react';
import { ContainerContextProvider } from "../store/ContainerContext";

export const wrapRootElement = ({ element }) => (
  <ContainerContextProvider>
    {element}
  </ContainerContextProvider>
);
